<app-row>
  <app-col cols="12" sm="auto">
    <div class="labeled-area__label">
      <div class="labeled-area__label-icon" *ngIf="icon">
        <app-icon type="MaterialDesign" [name]="icon.name" *ngIf="icon.type === IconType.MaterialDesign"></app-icon>
        <app-icon *ngIf="icon.type === IconType.SVG" [name]="icon.name"></app-icon>
        <img [src]="icon.name" *ngIf="icon.type === IconType.Image" />
      </div>
      <div class="labeled-area__label-text" *ngIf="label">{{label}}</div>
    </div>
  </app-col>
  <app-col>
    <ng-content></ng-content>
  </app-col>
</app-row>
